import { DateTime } from 'luxon';
import {
  Addons,
  Plan,
  PricingScheme,
  SubscriptionApiResponse,
  paddleClassicPricingSchemes,
} from '../../api/BillingApi';
import { CurrencyCode } from '../../config/CurrencyCode';
import { BillingStatus } from './Group';
import { BillingFrequency } from '../../config/Constants';
import translate, { Translations } from '../../language/translate';

export class Subscription {
  cancellationDate: DateTime;
  cancelUrl: string;
  currency: CurrencyCode;
  nextBillDate: DateTime;
  nextPaymentAmount: number;
  paddleSubscriptionId: number;
  pausedAt: DateTime;
  pausedFrom: DateTime;
  pausedReason: string;
  quantity: number;
  subscriptionPlanId: number;
  subscriptionStatus: BillingStatus;
  billingFrequency: BillingFrequency;
  updateUrl: string;
  plan: Plan;
  pricingStructure: PricingScheme;
  addons: Addons;

  static fromApi(apiData: SubscriptionApiResponse): Subscription {
    const sub = new Subscription();

    sub.cancellationDate = DateTime.fromISO(apiData.cancellationDate);
    sub.cancelUrl = apiData.cancelUrl;
    sub.currency = apiData.currency as CurrencyCode;
    sub.nextBillDate = DateTime.fromISO(apiData.nextBillDate);
    sub.nextPaymentAmount = apiData.nextPaymentAmount;
    sub.paddleSubscriptionId = apiData.paddleSubscriptionId;
    sub.pausedAt = DateTime.fromISO(apiData.pausedAt);
    sub.pausedFrom = DateTime.fromISO(apiData.pausedFrom);
    sub.pausedReason = apiData.pausedReason;
    sub.quantity = apiData.quantity;
    sub.subscriptionPlanId = apiData.subscriptionPlanId;
    sub.subscriptionStatus = apiData.subscriptionStatus as BillingStatus;
    sub.billingFrequency = apiData.billingFrequency as BillingFrequency;
    sub.updateUrl = apiData.updateUrl; // only used for classic paddle
    sub.plan = apiData.plan as Plan;
    sub.pricingStructure = apiData.pricingStructure as PricingScheme;
    sub.addons = apiData.addons;

    return sub;
  }

  static planName(plan: Plan): string {
    switch (plan) {
      case Plan.free:
        return translate(Translations.Billing.Plans.free.NAME);
      case Plan.full:
        return translate(Translations.Billing.Plans.full.NAME);
      case Plan.lite:
        return translate(Translations.Billing.Plans.lite.NAME);
      case Plan.active:
        return translate(Translations.Billing.Plans['202406'].active.NAME);
      case Plan.passive:
        return translate(Translations.Billing.Plans['202406'].passive.NAME);
      case Plan.advanced:
        return translate(Translations.Billing.Plans['202406'].advanced.NAME);
    }
  }

  get nicePlanName(): string {
    return Subscription.planName(this.plan);
  }

  isPaddleClassic = () => {
    return paddleClassicPricingSchemes.includes(this.pricingStructure);
  };
}
